export var ScreenId;
(function (ScreenId) {
    ScreenId["SelectPayment"] = "SelectPaymentScreen";
    ScreenId["DebitCard"] = "DebitCardScreen";
    ScreenId["Success"] = "SuccessScreen";
    ScreenId["Error"] = "ErrorScreen";
})(ScreenId || (ScreenId = {}));
export var MethodId;
(function (MethodId) {
    MethodId["DebitCard"] = "DebitCard";
})(MethodId || (MethodId = {}));
export var ObPageTypes;
(function (ObPageTypes) {
    ObPageTypes["ObDBCashier"] = "ObDBCashier";
    ObPageTypes["ObPMCarouselCashier"] = "ObPMCarouselCashier";
})(ObPageTypes || (ObPageTypes = {}));
//# sourceMappingURL=enums.js.map